import { render } from "./AdminBarcode.vue?vue&type=template&id=b111b03a"
import script from "./AdminBarcode.vue?vue&type=script&lang=js"
export * from "./AdminBarcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__